// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 2337636682
import { createAction } from 'typesafe-actions';

import type { DashboardConfig } from 'common/state/dashboard/types';

export const setDashboardConfig = createAction('DASHBOARD/SET_DASHBOARD_CONFIG')<DashboardConfig>();
